import {
  doc,
  setDoc,
  collection,
  query,
  where,
  getDocs,
  orderBy,
  limit
} from "firebase/firestore";
import { db } from "../../firebase";
import Cookies from "js-cookie";
import { Randomcode } from "../../components_root/rendom_code";

export const Save_cash_books = async (data) => {
  const {
    accountguid,
    voucherid,
    voucher_type,
    
    credit = 0,
    debit = 0
  } = data || {};

  // SAFE STRING VALIDATION
  if (!accountguid || typeof accountguid !== "string" || !accountguid.trim())
    return { success: false, error: "Missing accountguid" };

  if (!voucherid || typeof voucherid !== "string" || !voucherid.trim())
    return { success: false, error: "Missing voucherid" };

  if (!voucher_type || typeof voucher_type !== "string" || !voucher_type.trim())
    return { success: false, error: "Missing voucher_type" };

  // NUMERIC SANITIZATION
  const creditNum = Number(credit) || 0;
  const debitNum = Number(debit) || 0;

  if (creditNum < 0 || debitNum < 0)
    return { success: false, error: "Invalid credit/debit values." };

  if (creditNum > 0 && debitNum > 0)
    return { success: false, error: "Cannot use credit and debit together." };

  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");
  const select_company_uid = Cookies.get("select_company_uid");

  if (!sessiontoken) return { success: false, error: "Session expired. Please relogin." };
  if (!guid) return { success: false, error: "Login expired. Please relogin." };
  if (!select_company_uid) return { success: false, error: "Contact service provider." };
   const servicetablename = "accountingfinancedb";
  try {
    const ledgerCollection = collection(
      db,
      servicetablename,
      select_company_uid,
      "cash_books_accounting"
    );

    let balance = 0;

    // GET LAST ENTRY SAFELY
    const lastQuery = query(
      ledgerCollection,
      where("accountguid", "==", accountguid),
      orderBy("date_time", "desc"),
      limit(1)
    );

    const lastSnap = await getDocs(lastQuery);

    if (!lastSnap.empty) {
      const last = lastSnap.docs[0].data();
      const previousBalance = Number(last.balance) || 0;

      // STRICT NO MINUS BALANCE
      if (debitNum > 0) {
        if (debitNum > previousBalance) {
          return { success: false, error: "Insufficient balance. Debit not allowed." };
        }
        balance = previousBalance - debitNum;
      } else if (creditNum > 0) {
        balance = previousBalance + creditNum;
      } else {
        balance = previousBalance;
      }

      // EXTRA SAFETY: never allow negative
      if (balance < 0) {
        return { success: false, error: "Balance cannot go negative." };
      }

    } else {
      // FIRST ENTRY RULES
      if (debitNum > 0) {
        return { success: false, error: "Cannot start ledger with a debit entry." };
      }

      balance = creditNum;
    }

    // SAVE ENTRY
    const uid = Randomcode(24);

    const docRef = doc(
      db,
      servicetablename,
      select_company_uid,
      "cash_books_accounting",
      uid
    );

    const saveData = {
      ...data,
      cashid: uid,
      balance,
      credit: creditNum,
      debit: debitNum,
      companyuid: select_company_uid,
      guid,
      sessiontoken,
      date_time: new Date(),
      date_time_update: new Date()
    };

    await setDoc(docRef, saveData);

    return { success: true, balance };
  } catch (err) {
    console.error("Error saving ledger:", err);
    return { success: false, error: err?.message || "Unknown error" };
  }
};
